import { render, staticRenderFns } from "./ReadOnlyOrderBoxItem.vue?vue&type=template&id=4186d9f3&"
import script from "./ReadOnlyOrderBoxItem.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyOrderBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports